import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "thread-comment" }
const _hoisted_2 = { class: "thread-comment__body" }
const _hoisted_3 = { class: "thread-comment__name" }
const _hoisted_4 = { class: "thread-comment__username" }
const _hoisted_5 = { class: "thread-comment__time" }
const _hoisted_6 = { class: "thread-comment__text" }
const _hoisted_7 = { class: "thread-comment__actions" }
const _hoisted_8 = { class: "thread-comment__reply-action" }

import { computed } from 'vue'

import { Comment } from '@/models/interfaces'
import { calendar } from '@/helpers/time'


export default /*@__PURE__*/_defineComponent({
  __name: 'Comment',
  props: {
    comment: {}
  },
  emits: ['replyShow'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const posted = computed(() => {
  return calendar(props.comment.created)
})

const parentComment = computed(() => {
  if (props.comment.parent) {
    return props.comment.parent
  }
  return props.comment
})

function showReply(): void {
  emit('replyShow', parentComment.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "thread-comment__icon-wrapper" }, [
          _createElementVNode("span", { class: "iconfont iprofile-icon" })
        ], -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.comment.author.username), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(posted.value), 1)
      ]),
      _createElementVNode("span", _hoisted_6, _toDisplayString(__props.comment.text), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "iconfont ireply-icon" }, null, -1)),
          _createElementVNode("a", {
            class: "thread-comment__reply-text",
            onClick: _withModifiers(showReply, ["stop","prevent"])
          }, "Reply ")
        ])
      ])
    ])
  ]))
}
}

})